import React, { useCallback } from 'react';
import { Activity, FileEntry } from '@graphql/generated-graphql';
import { useFileEntry } from '@hooks/files/useFileEntry';
import { ActivityIconSVG } from '@components/common/svgs/ActivityIconSVG';
import { QuizActivitySVG } from '@components/common/svgs/QuizActivitySVG';
import { useCourseStateContext } from '@components/context/CourseContext';
import { useCourseActivitiesFixed } from '@hooks/courses/useCourseActivities';
import { UnitActivitiesMenuList } from './UnitsComponents';

export function ActivityMenuList({ unitId }: { unitId: string }) {
    const { data: course } = useCourseStateContext();
    const { data: units, isLoading } = useCourseActivitiesFixed({
        variables: {
            unitIds: [unitId],
            onlyVisible: true,
        },
    });

    const [unit] = units ?? [];
    const { activities } = unit ?? {};
    const imageUrl = useFileEntry({ file: unit?.imageFileEntry as FileEntry });

    const getSvg = useCallback(
        (act: Activity) => {
            return act?.item?.type === 'quiz' ? (
                <QuizActivitySVG className="stroke-current group-hover:stroke-teal-600" />
            ) : (
                <ActivityIconSVG className="stroke-current group-hover:stroke-teal-600" />
            );
        },
        [activities],
    );

    return (
        <UnitActivitiesMenuList
            getSvg={getSvg}
            imageUrl={imageUrl}
            iconColor={course?.iconColor ?? '#01AAB9'}
            title={unit?.title}
            isLoading={isLoading}
            activities={activities}
            unitId={unitId}
        />
    );
}
